// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".radio-button[data-v-b675e45a]{border-radius:8px;display:flex;align-items:center}.border-blue[data-v-b675e45a]{border:1px solid #0072ff}.border-gray[data-v-b675e45a]{border:1px solid #979ca1}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
